import * as types from '../constants/actionTypes'

export const hideNotification = (message) => {
  return {
    type: types.HideNotification,
    message,
  }
}

export const displayNotification = (
  message: string,
  className = 'success',
  duration = 3000
) => {
  return (dispatch) => {
    dispatch({
      type: types.ShowNotification,
      notification: {
        className,
        message,
      },
    })

    return new Promise<void>((resolve) => {
      setTimeout(() => {
        dispatch(hideNotification(message))
        resolve()
      }, duration)
    })
  }
}
